<template>
  <v-container fluid class="pa-8">
    <v-row>
      <v-col cols="12">
        <home-current-page />
        <br />
        <h2>Reservatórios</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <water-supply-map @volumesData="volumesData = $event">
        </water-supply-map>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <navigation-products-reservoirs
          :volumesData="volumesData"
        ></navigation-products-reservoirs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HomeCurrentPage from '../../components/common/HomeCurrentPage.vue';
import NavigationProductsReservoirs from '../../components/water_supply/NavigationProductsReservoirs';
import WaterSupplyMap from '../../components/water_supply/WaterSupplyMap.vue';
export default {
  components: {HomeCurrentPage, NavigationProductsReservoirs, WaterSupplyMap},
  data: () => ({
    basinSelected: 0,
    volumesData: undefined,
  }),
};
</script>

<style></style>
